import React from 'react'

import Modal from '../../../../components/structure/Modal'
import ShareDynamicServiceOrderForm from './ShareDynamicServiceOrderForm'
import {
  useCloseShareDynamicServiceOrder,
  useShareDynamicServiceOrder
} from './_context/ShareDynamicServiceOrderContext'

const ShareFormModal = () => {
  const form = useShareDynamicServiceOrder()
  const onClose = useCloseShareDynamicServiceOrder()

  return (
    <Modal open={!!form && !!form.id} onClose={onClose}>
      <ShareDynamicServiceOrderForm />
    </Modal>
  )
}

export default ShareFormModal
